import React from 'react';
import Container from "../../Components/Donation/Container";
import Footer from "../../Components/Donation/Footer/Footer";
import ScrollToTop from "../../Components/Donation/ScrollToTop";
import SEO from "../../Components/SEO/SEO";

const DonationPage = () => {
    return (
        <>
            <SEO 
                title="AmalgaMate - Unite, Decide, Create Change"
                description="Join communities, participate in voting & global insights, discuss trending topics, and support causes with AmalgaMate."
                image="/amalgamateA.svg"
                slugPath="/amalgamate"
            />
            <div className="DonationPage" style={{ backgroundColor: "black" }}>
                <ScrollToTop />
                <Container />
                <Footer />
            </div>
        </>
    );
};

export default DonationPage;